<template>
    <div class="change-name-container">
        <!-- 顶部导航栏 -->
        <div class="nav-bar">
            <img src="../assets/left-icon.png" alt="back" class="back-icon" @click="goBack" />
            <div class="nav-title">修改名字</div>
            <div class="nav-placeholder"></div>
        </div>

        <!-- 名称输入卡片 -->
        <div class="name-card">
            <div class="input-group">
                <label class="input-label">名字</label>
                <div class="input-wrapper">
                    <input type="text" v-model="userName" placeholder="" class="name-input" maxlength="20" />
                    <img v-if="userName" src="../assets/close-icon.png" alt="clear" class="clear-icon"
                        @click="clearName" />
                </div>
            </div>
        </div>

        <!-- 保存按钮 -->
        <button class="save-btn" @click="handleSave">保存</button>
    </div>
</template>

<script>
import { systemProfile } from '../api/apiList/system';

export default {
    name: 'ChangeName',
    data() {
        return {
            userName: ''
        };
    },
    mounted() {
        const profileData = JSON.parse(localStorage.getItem('profileData'));
        if (profileData && profileData.first_name) {
            this.userName = profileData.first_name;
        }
    },
    methods: {
        goBack() {
            this.$router.back();
        },
        clearName() {
            this.userName = '';
        },
        async handleSave() {
            if (!this.userName) {
                this.$toast('请输入名称')
                return;
            }
            if (this.userName.trim().length < 2) {
                this.$toast('名称至少需要2个字符')
                return;
            }
            let info = await systemProfile({
                first_name: this.userName
            })
            if (info.id) {
                info.avatar = 'data:image/png;base64,' + info.avatar
                localStorage.setItem('profileData', JSON.stringify(info))
                this.$toast('修改名称成功')
            }
        }
    }
};
</script>

<style scoped>
.change-name-container {
    width: 100%;
    min-height: 100vh;
    background-color: #000;
    color: #fff;
    padding: 0;
}

/* 顶部导航栏 */
.nav-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    position: sticky;
    top: 0;
    background-color: #000;
    z-index: 100;
}

.back-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.nav-title {
    font-size: 17px;
    font-weight: 500;
    color: #fff;
}

.nav-placeholder {
    width: 20px;
}

/* 名称输入卡片 */
.name-card {
    background-color: #1a1a1a;
    border-radius: 16px;
    padding: 20px 20px 0;
    margin: 0 20px 20px;
}

.input-group {
    padding: 0 0 20px;
}

.input-label {
    display: block;
    font-size: 15px;
    color: #999;
    margin-bottom: 5px;
}

.input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.name-input {
    width: 100%;
    background: transparent;
    border: none;
    border-bottom: 1px solid #333;
    outline: none;
    color: #fff;
    font-size: 15px;
    padding: 10px 30px 10px 0;
}

.name-input::placeholder {
    color: rgba(255, 255, 255, 0.3);
}

.clear-icon {
    position: absolute;
    right: 0;
    width: 16px;
    height: 16px;
    opacity: 0.5;
    cursor: pointer;
}

/* 保存按钮 */
.save-btn {
    height: 50px;
    background: linear-gradient(180deg, #36D8AF 0%, #10BDA7 100%);
    border: none;
    border-radius: 25px;
    color: #000;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    position: fixed;
    bottom: 20px;
    left: 20px;
    right: 20px;
}

.save-btn:active {
    opacity: 0.8;
}
</style>
